export default __webpack_public_path__ + "static/illustration-card-two.url-486130f101040f7baac517d72cab3745.svg";